import {Injectable} from '@angular/core';
import {FormControl, Validators, FormBuilder, FormGroup, AbstractControl} from "@angular/forms";

@Injectable()
export class PedidoParcelaModel {

  field: any = {

    codemp: <string>'',
    codfil: <string>'',
    filial: <string>'',
    seqpar: <string>'',
    numped: <string>'',

    inspar: <string>'',
    updpar: <string>'',
    excpar: <string>'',

    codcrp: <string>'',

    codfcr: <string>'',
    desfcr: <string>'',

    codpor: <string>'',
    despor: <string>'',

    codfpg: <string>'',
    desfpg: <string>'',

    codtpt: <string>'',
    destpt: <string>'',

    dscpar: <string>'',
    vlrpar: <string>'',
    vctpar: <string>'',
    diapar: <string>''
  };

  constructor(public formBuilder: FormBuilder) {
    this.resetForm();
  }

  resetForm() {
    for (let prop in this.field) {
        eval("this.field." + prop + " = '' ");
    }
  }

}



// WEBPACK FOOTER //
// ./src/model/pedido-parcela.model.ts